import React from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';
import anime from 'animejs';

const duration = 200;
export default class CollapsibleTransition extends React.Component {
  onEnter = node => {
    if (!node) return;
    const height = node.scrollHeight;
    anime({
      targets: node,
      height: [0, `${height}px`],
      opacity: [0.5, 1],
      duration,
      easing: 'easeOutQuad',
      complete: () => {
        node.style.height = 'auto';
      }
    });
  };

  onExit = node => {
    if (!node) return;
    const height = node.scrollHeight;
    anime({
      targets: node,
      height: [`${height}px`, 0],
      opacity: [1, 0],
      duration: 0,
      easing: 'easeInQuad'
    });
  };

  render() {
    const { children, transitionkey, in: inProp } = this.props;
    return (
      <Transition
        appear
        in={inProp}
        key={transitionkey}
        timeout={{ enter: duration, exit: 0 }}
        onEnter={this.onEnter}
        onExit={this.onExit}>
        {children}
      </Transition>
    );
  }
}
CollapsibleTransition.propTypes = {
  transitionkey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.element
};
